export const SEGMENT_RULE_LIMIT = 5;

export const operatorRequiresUnitCountFormat = {
    'withinLast': true,
    '!withinLast': true,
};

// keys match `/api/s/_SID_/metadata/:kind/schema` schema obj.schema
const numberOperators = [
    {
        id: 'number-equals',
        value: '==',
        label: 'equals',
    },
    {
        id: 'number-not-equals',
        value: '!=',
        label: 'does not equal',
    },
    {
        id: 'number-gte',
        value: '>=',
        label: 'greater than or equal to',
    },
    {
        id: 'number-lte',
        value: '<=',
        label: 'less than or equal to',
    },
];

export const SEGMENT_OPERATORS = {
    guideElement: [
        {
            id: 'guide-element-clicked',
            value: 'clicked',
            label: 'clicked',
        },
        {
            id: 'guide-element-not-clicked',
            value: 'notclicked',
            label: 'not clicked',
        },
    ],
    integer: numberOperators,
    float: numberOperators,
    time: [
        {
            id: 'time-before',
            value: '<=',
            label: 'before',
            multivalue: false,
        },
        {
            id: 'time-since',
            value: '>=',
            label: 'since',
            multivalue: false,
        },
        {
            id: 'time-between',
            value: 'between',
            label: 'between',
            multivalue: true,
        },
        {
            id: 'time-within-last',
            value: 'withinLast',
            label: 'within last',
            multivalue: true,
        },
        {
            id: 'time-not-within-last',
            value: '!withinLast',
            label: 'not within last',
            multivalue: true,
        },
    ],
    string: [
        {
            id: 'string-contains',
            value: 'contains',
            label: 'contains',
        },
        {
            id: 'string-not-contains',
            value: '!contains',
            label: 'does not contain',
        },
        {
            id: 'string-equals',
            value: '==',
            label: 'equals',
        },
        {
            id: 'string-not-equals',
            value: '!=',
            label: 'does not equal',
        },
        {
            id: 'string-starts-with',
            value: 'startsWith',
            label: 'starts with',
        },
        {
            id: 'string-not-starts-with',
            value: '!startsWith',
            label: 'does not start with',
        },
        {
            id: 'string-list-contains',
            value: 'listContains',
            label: 'csv contains',
        },
        {
            id: 'string-list-not-contains',
            value: '!listContains',
            label: 'csv does not contain',
        },
    ],
    boolean: [
        {
            id: 'boolean-true',
            value: '==',
            unary: true,
            label: 'is true',
        },
        {
            id: 'boolean-false',
            value: '!=',
            unary: true,
            label: 'is false',
        },
    ],
    list: [
        {
            id: 'list-contains',
            value: 'contains',
            label: 'contains',
        },
        {
            id: 'list-not-contains',
            value: '!contains',
            label: 'does not contain',
        },
    ],
    guide: [
        {
            id: 'guide-viewed',
            value: 'viewed',
            label: 'seen',
        },
        {
            id: 'guide-last-viewed',
            value: 'lastviewed',
            label: 'last seen',
        },
        {
            id: 'guide-not-viewed',
            value: 'notviewed',
            label: 'not seen',
        },
    ],
    page: [
        {
            id: 'page-viewed',
            value: 'viewed',
            label: 'seen',
        },
        {
            id: 'page-last-viewed',
            value: 'lastviewed',
            label: 'last seen',
        },
        {
            id: 'page-not-viewed',
            value: 'notviewed',
            label: 'not seen',
        },
    ],
    segment: [
        {
            id: 'segment-equals',
            value: '==',
            label: 'equals',
        },
        {
            id: 'segment-not-equals',
            value: '!=',
            label: 'does not equal',
        },
    ],
    feature: [
        {
            id: 'feature-clicked',
            value: 'clicked',
            label: 'clicked',
        },
        {
            id: 'feature-last-clicked',
            value: 'lastclicked',
            label: 'last clicked',
        },
        {
            id: 'feature-not-clicked',
            value: 'notclicked',
            label: 'not clicked',
        },
    ],
    poll: [
        {
            id: 'poll-equals',
            value: '==',
            label: 'equals',
        },
        {
            id: 'poll-not-equals',
            value: '!=',
            label: 'does not equal',
        },
        {
            id: 'poll-contains',
            value: 'contains',
            label: 'contains',
        },
        {
            id: 'poll-not-contains',
            value: '!contains',
            label: 'does not contain',
        },
        {
            id: 'poll-responded',
            value: 'responded',
            label: 'responded',
        },
        {
            id: 'poll-not-responded',
            value: 'notresponded',
            label: 'not responded',
        },
    ],
    application: [
        {
            id: 'application-used',
            value: 'used',
            label: 'used',
        },
        {
            id: 'application-not-used',
            value: 'notused',
            label: 'not used',
        },
    ],
    workflow: [
        {
            id: 'workflow-completed',
            value: 'completed',
            label: 'Completed',
        },
        {
            id: 'workflow-incomplete',
            value: 'incomplete',
            label: 'Incomplete',
        },
        {
            id: 'workflow-not-started',
            value: 'notStarted',
            label: 'Not Started',
        },
    ],
    workflowNonRS: [
        {
            id: 'workflow-non-rs-completed',
            value: 'completed',
            label: 'Completed',
        },
        {
            id: 'workflow-non-rs-not-completed',
            value: 'notcompleted',
            label: 'Incomplete or Not Started',
        },
    ],
    trackType: [
        {
            id: 'track-type-used',
            value: 'used',
            label: 'used',
        },
        {
            id: 'track-type-not-used',
            value: 'notused',
            label: 'not used',
        },
        {
            id: 'track-type-last-used',
            value: 'lastused',
            label: 'last used',
        },
    ],
};

export const GUIDE_TIME_RANGE_SEEN_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'before', value: '<=' },
    { label: 'since', value: '>=' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'at least', value: 'atleast' },
    { label: 'at most', value: 'atmost' },
];

export const GUIDE_TIME_RANGE_LAST_SEEN_OPTIONS = [
    { label: 'before', value: '<=' },
    { label: 'since', value: '>=' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'between', value: 'between' },
];

export const GUIDE_TIME_RANGE_NOT_SEEN_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'before', value: '<=' },
    { label: 'since', value: '>=' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
];

export const PAGE_TIME_RANGE_VIEWED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
    { label: 'at least', value: 'atleast' },
    { label: 'at most', value: 'atmost' },
];

export const PAGE_TIME_RANGE_LAST_VIEWED_OPTIONS = [
    { label: 'before', value: 'before' },
    { label: 'since', value: 'since' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'between', value: 'between' },
];

export const PAGE_TIME_RANGE_NOT_VIEWED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const FEATURE_TIME_RANGE_CLICKED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
    { label: 'at least', value: 'atleast' },
    { label: 'at most', value: 'atmost' },
];

export const FEATURE_TIME_RANGE_LAST_CLICKED_OPTIONS = [
    { label: 'before', value: 'before' },
    { label: 'since', value: 'since' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'between', value: 'between' },
];

export const FEATURE_TIME_RANGE_NOT_CLICKED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const GUIDE_ELEMENT_TIME_RANGE_CLICKED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
    { label: 'at least', value: 'atleast' },
    { label: 'at most', value: 'atmost' },
];

export const GUIDE_ELEMENT_TIME_RANGE_NOT_CLICKED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const APP_USAGE_TIME_RANGE_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const POLL_TIME_RANGE_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'before', value: '<=' },
    { label: 'since', value: '>=' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'between', value: 'between' },
];

export const INPUT_OPTIONS_MAP = {
    PICK_LIST: 'PickList',
    FREE_FORM: 'FreeForm',
    NUMBER_SCALE: 'NumberScale',
    POSITIVE_NEGATIVE: 'PositiveNegative',
};

export const WORKFLOW_TIME_RANGE_COMPLETED_INCOMPLETE_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const WORKFLOW_TIME_RANGE_NOT_STARTED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const TRACK_TYPE_TIME_RANGE_USED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const TRACK_TYPE_TIME_RANGE_NOT_USED_OPTIONS = [
    { label: 'ever', value: 'ever' },
    { label: 'within last', value: 'withinlast' },
    { label: 'since', value: 'since' },
];

export const TRACK_TYPE_TIME_RANGE_LAST_USED_OPTIONS = [
    { label: 'before', value: 'before' },
    { label: 'since', value: 'since' },
    { label: 'within last', value: 'withinlast' },
    { label: 'not within last', value: '!withinlast' },
    { label: 'between', value: 'between' },
];

export const DEFAULT_SEGMENT_IDS_MAP = {
    _VIA_DEFAULT_FV0to30: true,
    _VIA_DEFAULT_FV30to60: true,
    _VIA_DEFAULT_FV60to90: true,
    _VIA_DEFAULT_FVover30: true,
    _PENDO_DEFAULT_FV0to30: true,
    _PENDO_DEFAULT_FVover30: true,
    _PENDO_DEFAULT_FV30to60: true,
    _PENDO_DEFAULT_FV60to90: true,
    _PENDO_DEFAULT_BrChrome: true,
    _PENDO_DEFAULT_BrSafari: true,
    _PENDO_DEFAULT_BrMSIE: true,
};
